export default __webpack_public_path__ + "61aaed4430695bd4bdb279a17e168895.svg";